import React, { useState } from 'react';
import styles from '../styles/licenseTemplate.module.css';
// import { createLicenseTemplate } from '../../../api/licenses/post';

const LicenseTemplate = () => {
  const [licenseName, setLicenseName] = useState('');
  const [category, setCategory] = useState('');
  const [uploadRequired, setUploadRequired] = useState(false);
  const [exp120, setExp120] = useState(false);
  const [exp90, setExp90] = useState(false);
  const [exp30, setExp30] = useState(false);

  const [req30, setReq30] = useState(false);
  const [req14, setReq14] = useState(false);
  const [req7, setReq7] = useState(false);

  const categories = [
    '',
    'State Requirement', // Guard cards, firearms permits, PPO, PI licenses
    'Professional', // CPR, EMT, LEOSA, EP-specific courses
    'Company Requirement', // MSB-specific onboarding, NDAs, internal SOP training
    'Compliance', // HR, OSHA, insurance, policy acknowledgments
    'Federal', // TWIC, TSA, DHS credentials, LEOSA (national level)
    'Vehicle/Equipment', // Defensive driving, vehicle insurance, radio certification
    'Medical', // CPR/AED, EMT-B, Tactical First Aid (TCCC)
    'Technical', // CCTV, drone ops, report-writing, cybersecurity
    'Management/Administrative', // Supervisor/managerial, report compliance, use-of-force reviews
    'Other',
  ];

  // function handleSumbit() {
  //   try {
  //     // createLicenseTemplate()
  //   } catch (err) {
  //     alert(err);
  //   }
  // }

  return (
    <div className={styles.wrapper}>
      <div className={styles.leftContainer}></div>

      <div className={styles.middleContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>License Name</p>
          <input
            required
            value={licenseName}
            onChange={(e) => setLicenseName(e.target.value)}
            className={styles.inputElement}
          />
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Category</p>
          <select
            onChange={(e) => setCategory(e.target.value)}
            value={category}
            className={styles.inputElement}
          >
            <option value="">Select Category</option>
            {categories
              .filter((c) => c !== '')
              .map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
          </select>
        </div>

        <div className={styles.optionsMasterContainer}>
          <p className={styles.label}>Options</p>
          <div className={styles.optionsBorderContainer}>
            <div className={styles.checkboxGroup}>
              <input
                type="checkbox"
                checked={uploadRequired}
                onChange={() => setUploadRequired(!uploadRequired)}
              />
              <p className={styles.checkboxLabel}>Upload Required</p>
            </div>
            <p className={styles.optionsSubLabel}>Expiration Reminders</p>
            <div className={styles.checkboxRowContainer}>
              <div className={styles.checkboxGroup}>
                <input
                  type="checkbox"
                  checked={exp120}
                  onChange={() => setExp120(!exp120)}
                />
                <p className={styles.checkboxLabel}>120 days before</p>
              </div>

              <div className={styles.checkboxGroup}>
                <input
                  type="checkbox"
                  checked={exp90}
                  onChange={() => setExp90(!exp90)}
                />
                <p className={styles.checkboxLabel}>90 days before</p>
              </div>

              <div className={styles.checkboxGroup}>
                <input
                  type="checkbox"
                  checked={exp30}
                  onChange={() => setExp30(!exp30)}
                />
                <p className={styles.checkboxLabel}>30 days before</p>
              </div>
            </div>

            <p className={styles.optionsSubLabel}>Requalification Reminders</p>
            <div className={styles.checkboxRowContainer}>
              <div className={styles.checkboxGroup}>
                <input
                  type="checkbox"
                  checked={req30}
                  onChange={() => setReq30(!req30)}
                />
                <p className={styles.checkboxLabel}>30 days before</p>
              </div>

              <div className={styles.checkboxGroup}>
                <input
                  type="checkbox"
                  checked={req14}
                  onChange={() => setReq14(!req14)}
                />
                <p className={styles.checkboxLabel}>14 days before</p>
              </div>

              <div className={styles.checkboxGroup}>
                <input
                  type="checkbox"
                  checked={req7}
                  onChange={() => setReq7(!req7)}
                />
                <p className={styles.checkboxLabel}>7 days before</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LicenseTemplate;
